import { Component } from '@angular/core';

@Component({
  templateUrl: './if-page-load.component.html',
  styleUrls: ['./if-page-load.component.scss'],
  selector: 'if-page-load'
})
export class IFPageLoadComponent {}
